<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['labels', 'dataPoints'],
  mounted () {
    this.renderChart({
      labels: this.labels,
      datasets: [
        {
          label: 'Average Number of Wifi Users',
          backgroundColor: ['#BA55D3', '#8A2BE2', '#800080', '#9932CC', '#4B0082', '#800080', '#8B008B'],
          data: this.dataPoints
        }
      ]
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/views/charts/BarExample.vue